import React from 'react'
import {makeStyles, Typography} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  term: {
    float: 'left',
    width: '156px',
    overflow: 'hidden',
    clear: 'left',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    color: '#5d7079',
  },
  definition: {
    marginBottom: theme.spacing(2),
    marginLeft: '180px',
    fontSize: '16px',
  },
}))

export default function DefinitionListItem({term, definition}) {
  const classes = useStyles()

  return (
    <div>
      <Typography component="dt" className={classes.term}>
        {term}
      </Typography>
      <Typography component="dd" className={classes.definition}>
        {definition || '-'}
      </Typography>
    </div>
  )
}
